import { render, staticRenderFns } from "./DeleteNormalizedNameDialog.vue?vue&type=template&id=4104538d"
import script from "./DeleteNormalizedNameDialog.vue?vue&type=script&lang=js"
export * from "./DeleteNormalizedNameDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteNormalizedNameDialog.vue?vue&type=style&index=0&id=4104538d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports